import * as ReactDOM from 'react-dom';
import { Route } from 'react-router';

import { legacyTheme, lightTheme } from '@dsx/react';
import BrowserUnsupported from '../../containers/BrowserUnsupported';
import ExternalLayout from '../../containers/ExternalLayout';
import Login from '../../containers/Login';
import NotFound from '../../containers/NotFound';
import { CommonProvider } from '../CommonProvider';

import { startGoogleAnalytics } from '../../analytics';
import { setBrandingTokens } from '../../branding';
import SingleSignOn, {
	SSOExpired,
	SSOUnauthorized,
} from '../../containers/SingleSignOn';
import brandingTokens from './branding-tokens';
import messages from './messages';
import { createLoginStore } from '~/store';

document.body.classList.add(legacyTheme, lightTheme);

startGoogleAnalytics();
setBrandingTokens(brandingTokens);

const routes = (
	<Route component={ExternalLayout}>
		<Route path="/login" components={{ body: Login }} />
		<Route
			path="/singleSignOn/unauthorized"
			components={{ body: SSOUnauthorized }}
		/>
		<Route path="/singleSignOn/expired" components={{ body: SSOExpired }} />
		<Route path="/singleSignOn" components={{ body: SingleSignOn }} />
		<Route
			path="/browserUnsupported"
			components={{ body: BrowserUnsupported }}
		/>
		<Route path="*" components={{ body: NotFound }} />
	</Route>
);

const store = createLoginStore();

ReactDOM.render(
	<CommonProvider localeMessages={messages} store={store} routes={routes} />,
	document.getElementById('react-app')
);
